var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextSlide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88546 11.2929L13.3328 19.7405C13.5654 19.9726 13.6933 20.2828 13.6933 20.6137C13.6933 20.9447 13.5654 21.2547 13.3328 21.4871L12.5926 22.227C12.3603 22.4598 12.0499 22.5879 11.7191 22.5879C11.3883 22.5879 11.0782 22.4598 10.8458 22.227L0.787927 12.1693C0.554595 11.9361 0.426822 11.6246 0.42774 11.2934C0.426822 10.9608 0.554411 10.6496 0.787927 10.4163L10.8364 0.368318C11.0688 0.135537 11.3789 0.00739575 11.7099 0.00739578C12.0407 0.00739581 12.3508 0.135537 12.5834 0.368318L13.3234 1.10815C13.8049 1.58968 13.8049 2.37358 13.3234 2.85493L4.88546 11.2929Z",
    fill: "#1D4EAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextSlide);
export default __webpack_public_path__ + "static/media/nextSlide.2a9c029d7376aec4f88de6abfcc19d47.svg";
export { ForwardRef as ReactComponent };